import { FluidStockView } from 'models';
import { FluidStockStatsView } from 'models/detail/FluidStockStatsView';
import { API_URL } from 'utils/constants';
import { RequestHelper } from 'utils/helpers';
import { SelectItem } from 'utils/types';

const stocksUrl = `${API_URL}stocks`;
const fluidUrl = `${API_URL}fluids`;

// GET
const getAllStocks: () => Promise<FluidStockView[]> = () => RequestHelper.GET(`${stocksUrl}`);

const getDetailStock: (
  id: string,
  year: SelectItem
) => Promise<FluidStockStatsView> = (label, year) => RequestHelper.GET(`${fluidUrl}/${label}/stocks?year=${year}`);

const getValidationList = () => RequestHelper.GET(`${stocksUrl}/validation-list`);

// POST
const validateStock = bottleList => RequestHelper.POST(`${stocksUrl}/validate`, bottleList);

const importStocks = document => RequestHelper.POST(`${stocksUrl}/import`, document);

export const StocksService = {
  getAllStocks,
  getDetailStock,
  getValidationList,
  validateStock,
  importStocks
};
